import React from "react";
import { styled } from "../stitches.config";
import { body, bodySmall } from "./commonStyles/Fonts";

interface FootnotesAtavistProps {
    footnotes?: string;
}

export const FootnotesAtavist: React.FC<FootnotesAtavistProps> = ({
    footnotes,
}) => {
    return (
        <>
            {footnotes && <FootnotesAtavistWrapper className={bodySmall()}>
                <p><sup>*</sup>{footnotes}</p>
            </FootnotesAtavistWrapper>}
        </>
    );
};



const FootnotesAtavistWrapper = styled("div", {
    margin: "16px 16px 0 16px ",
    maxWidth: "840px",
    "@bp4": {
        margin: "24px auto 0 auto",
    },
    "p": {
        color: "$grayscale75",
        margin: 0,
    },
    "sup": {
        fontSize: "16px",
        lineHeight: "12px",
        top: 0,
        color: "$primary"
    }
});

export default FootnotesAtavist;
